export const SEARCH_ALL_RETAILERS = 'SEARCH_ALL_RETAILERS';
